import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1468.23529,113 L1468.23529,204.142488 L822.674025,862.889857 C806.765611,879.394022 797.938192,901.462569 798.075895,924.385181 L798.07387,1354.24398 C797.833891,1354.60997 797.597478,1354.97963 797.364706,1355.35294 C773.647059,1398.27059 718.305882,1460.38824 684.423529,1457 C650.541176,1453.61176 640.376471,1429.89412 612.141176,1361 C576,1271.77647 517.270588,1154.31765 421.270588,1163.35294 C300.423529,1173.51765 241.694118,1389.23529 221.364706,1484.10588 C214.815258,1515.29373 234.788626,1545.88585 265.976471,1552.43529 C297.164315,1558.98474 327.756435,1539.01137 334.305882,1507.82353 C346.721038,1425.43021 380.174711,1347.63097 431.435294,1281.94118 C431.435294,1281.94118 461.929412,1292.10588 509.364706,1409.56471 C556.8,1527.02353 608.752941,1571.07059 678.776471,1575.58824 L687.811765,1575.58824 C800.752941,1575.58824 884.329412,1432.15294 893.364706,1415.21176 C903.401798,1399.11454 904.36106,1379.92728 897.630818,1363.63712 L1237.32821,1363.63749 C1260.50046,1363.30743 1282.60366,1353.83463 1298.82353,1337.28235 L1468.23529,1164.41022 L1468.23529,1807.11765 L0,1807.11765 L0,113 L1468.23529,113 Z M564.705882,677.705882 L225.882353,677.705882 L225.882353,790.647059 L564.705882,790.647059 L564.705882,677.705882 Z M790.588235,451.823529 L225.882353,451.823529 L225.882353,564.764706 L790.588235,564.764706 L790.588235,451.823529 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1903.05882,468.764706 L1677.17647,242.882353 C1666.57318,232.191756 1652.13953,226.178448 1637.08235,226.178448 C1622.02517,226.178448 1607.59153,232.191756 1596.98824,242.882353 L919.341176,920.529412 C909.115192,931.138347 903.440895,945.324088 903.528392,960.058824 L903.528392,1242.41176 L1185.88235,1242.41176 C1200.77756,1242.1996 1214.98557,1236.11045 1225.41176,1225.47059 L1903.05882,547.823529 C1924.58219,525.865308 1924.58219,490.722928 1903.05882,468.764706 Z M1694.11765,597.517647 L1548.42353,451.823529 L1637.64706,362.6 L1783.34118,508.294118 L1694.11765,597.517647 Z"
}));

var IconAnnotateSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconAnnotateSolid, _Component);

  var _super = _createSuper(IconAnnotateSolid);

  function IconAnnotateSolid() {
    _classCallCheck(this, IconAnnotateSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconAnnotateSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAnnotate",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconAnnotateSolid.displayName = "IconAnnotateSolid";
  return IconAnnotateSolid;
}(Component);

IconAnnotateSolid.glyphName = 'annotate';
IconAnnotateSolid.variant = 'Solid';
IconAnnotateSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAnnotateSolid;
export { IconAnnotateSolid };